<template>
  <div id="app">
    <v-col cols="12" class="text-center">
      <h1 class="text-uppercase" v-show="getNews.length != 0">NOTICIAS</h1>
    </v-col>
    <vue-horizontal-list
      :items="getNews"
      :options="{
        responsive: [
          { end: 576, size: 1 },
          { start: 576, end: 768, size: 2 },
          { start: 768, end: 992, size: 3 },
          { size: 3 },
        ],
      }"
    >
      <template v-slot:default="{ item }">
        <v-row>
          <v-col cols="11" lg="11" md="11">
            <v-card
              class="mx-auto"
              height="380"
              max-width="400"
              @click="goDetail(item)"
            >
              <v-img
                class="white--text align-end"
                height="200px"
                :src="item.images ? item.images[0] : imageLocal"
              ></v-img>
              <v-card-title class="title text-left font-weight-bold ">
                {{ truncate(item.title, 85) }}
              </v-card-title>

              <v-card-actions>
                <p class="  text-uppercase ">
                  {{ item.created | date }}
                </p>

                <v-spacer></v-spacer>

                <p class="ml-6 text-uppercase category">
                  {{ item.category }}
                </p>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </vue-horizontal-list>
    <v-btn rounded depressed to="/allNews" color="primary">
      VER TODAS
    </v-btn>
  </div>
</template>

<script>
import VueHorizontalList from "vue-horizontal-list";
import { mapGetters, mapState, mapActions } from "vuex";
import { formatDateNew } from "../../filters";
export default {
  name: "ExampleHorizontalList",
  filters: {
    date(value) {
      return formatDateNew(value);
    },
  },
  components: { VueHorizontalList },
  data: () => ({
    imageLocal: "https://cdn.vuetifyjs.com/images/cards/docks.jpg",
  }),
  created() {
    this.loadNews();
  },
  // computed: mapState({
  //   news: (state) =>
  //     state.news.sort(
  //       (a, b) => formatDateNew(a.created) > formatDateNew(b.created)
  //     ),
  // }),
  computed: {
    ...mapGetters(["news"]),
    getNews() {
      var newsResult = this.news.sort(
        (a, b) => b.created.seconds - a.created.seconds
      );

      return newsResult;
    },
  },
  methods: {
    ...mapActions(["loadNews"]),
    goDetail(item) {
      this.$router.push("newsDetail/" + item.id);
    },
    truncate(source, size) {
      return source.length > size ? source.slice(0, size - 1) + "…" : source;
    },
  },
};
</script>

<style scoped lang="css">
body {
  margin: 0;
  padding: 0;
}

#app {
  max-width: 1400px;

  margin-left: auto;
  margin-right: auto;
}
.category {
  color: green;
}
</style>
